export const LOAD_BRANDS_SUCCESS = 'LOAD_BRANDS_SUCCESS';
export const SELECT_YOUR_X_INDEX_CHANGED = 'SELECT_YOUR_X_INDEX_CHANGED';
export const LOAD_DEVICES_SUCCESS = 'LOAD_DEVICES_SUCCESS';
export const LOAD_MODELS_SUCCESS = 'LOAD_MODELS_SUCCESS';
export const SELECT_YOUR_X_DROPDOWN_TOGGLE = 'SELECT_YOUR_X_DROPDOWN_TOGGLE';
export const SAVE_SELECTED_BRAND = 'SAVE_SELECTED_BRAND';
export const SAVE_SELECTED_DEVICE = 'SAVE_SELECTED_DEVICE';
export const LOAD_AD_SUCCESS = 'LOAD_AD_SUCCESS';
export const LOAD_CONFIGPROPS_SUCCESS = 'LOAD_CONFIGPROPS_SUCCESS';
export const RESET_FORM_TO_DEFAULT = 'RESET_FORM_TO_DEFAULT';
export const SET_FINDER_TYPE_ID = 'SET_FINDER_TYPE_ID';